
import { defineComponent } from "@vue/composition-api";
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { mapState } from "pinia";
import Vue from "vue";

import AddDataCat from "@/components/AddDataCat.vue";
import AddDataRefCat from "@/components/AddDataRefCat.vue";
import AddUpdateCat from "@/components/AddUpdateCat.vue";
import AddUpdateLog from "@/components/AddUpdateLog.vue";
import AddDataDesc from "@/components/AddDataDesc.vue";
import AddFieldCat from "@/components/AddFieldCat.vue";

export default defineComponent({
  name: "AddNewMetadata",
  components: {
    AddDataCat,
    AddDataRefCat,
    AddUpdateCat,
    AddUpdateLog,
    AddDataDesc,
    AddFieldCat,
  },
  props: {
    whichMetadata: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    startDataCat: true,
    startDataRefCat: false,
    startUpdateCat: false,
    startUpdateLog: false,
    startDataDesc: false,
    startFieldCat: false,

    dpRequest: {} as IDataProviderRequest,
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, ["updateLogId", "selectedDataCatId"]),
    selectedDataCatId: {
      get(): number {
        return useMetadataCatalog().selectedDataCatId;
      },
      set(val: number) {
        useMetadataCatalog().selectedDataCatId = val;
      },
    },
    updateLogId: {
      get(): number {
        return useMetadataCatalog().updateLogId;
      },
      set(val: number) {
        useMetadataCatalog().updateLogId = val;
      },
    },
  },
  mounted() {
    if (this.whichMetadata !== null) {
      this.showUpdatePage(this.whichMetadata);
    }
  },
  methods: {
    showUpdatePage(catName: string) {
      this.hideAll();
      switch (catName) {
        case "data_cat":
          this.startDataCat = true;
          break;
        case "data_reference_cat":
          this.startDataRefCat = true;
          break;
        case "update_cat":
          this.startUpdateCat = true;
          break;
        case "update_log":
          this.startUpdateLog = true;
          break;
        case "data_desc_cat":
          this.startDataDesc = true;
          break;
        case "field_cat":
          this.startFieldCat = true;
          break;
        default:
          this.showMessage(
            "danger",
            "Retry! Couldn't find the catalogue name! " + catName
          );
          break;
      }
    },
    hideAll() {
      this.startDataCat = false;
      this.startDataRefCat = false;
      this.startUpdateCat = false;
      this.startUpdateLog = false;
      this.startDataDesc = false;
      this.startFieldCat = false;
    },
    nextUpdatePage(page: string) {
      this.showUpdatePage(page);
    },
    reloadData() {
      window.location.reload();
    },
    async updateDB(
      requestFrom: string,
      param: string,
      dataCatEntry: Record<string, any>,
      nextPage: string,
      catUri: string,
      insertUri: string
    ) {
      if (param === "skip") {
        this.nextUpdatePage(nextPage);
      } else {
        let emptyField = false;
        let colsToBeInserted: { column: { columnName: string }; value: any }[] =
          [];
        Object.entries(dataCatEntry).map(([key, val]) => {
          if (val?.val !== null && val?.val !== "") {
            colsToBeInserted.push({
              column: {
                columnName: key,
              },
              value: useMetadataCatalog().getValOfKey(key, val),
            });
          } else if (val.isRequired) {
            emptyField = true;
          }
        });
        if (!emptyField) {
          const response = await useMetadataCatalog().insertMetadata({
            catalogUri: insertUri,
            request: {
              columnInserts: colsToBeInserted,
            },
          });
          // const response = 200;
          if (response) {
            if (response === 200) {
              this.showMessage("success", "Successfully updated!");
              await this.checkUpdateRequest(requestFrom, dataCatEntry, catUri);

              if (param === "repeat") {
                if (requestFrom === "data_ref_cat") {
                  (
                    this.$refs.refDataRefCat as Vue & {
                      resetVar: () => boolean;
                    }
                  ).resetVar();
                } else if (requestFrom === "field_cat") {
                  (
                    this.$refs.refFieldCat as Vue & { resetVar: () => boolean }
                  ).resetVar();
                }
              } else if (param === "next") {
                this.nextUpdatePage(nextPage);
              } else {
                window.location.reload();
              }
            } else {
              // failed response
              this.showMessage(
                "danger",
                "Something is wrong! Status code " + response
              );
            }
          } else {
            // response not generated
            this.showMessage("danger", "Something is wrong! Empty response!");
          }
        } else {
          // found empty field
          this.showMessage("danger", "Please fill all star marked fields!");
        }
      }
    },
    async checkUpdateRequest(
      requestFrom: string,
      dataCatEntry: any,
      catUri: string
    ) {
      switch (requestFrom) {
        case "data_cat":
          await this.getCreatedDataCatId(dataCatEntry, catUri);
          break;
        case "data_ref_cat":
          // this.startDataRefCat = true;
          break;
        case "update_cat":
          // this.startUpdateCat = true;
          break;
        case "update_log":
          await this.setUpdateLogId(catUri);
          break;
        case "data_desc_cat":
          // this.startDataDesc = true;
          break;
        case "field_cat":
          // this.startFieldCat = true;
          break;
        case "endWorkflow":
          // this.startFieldCat = true;
          break;
        default:
          this.showMessage(
            "danger",
            "Retry! Couldn't recognise the requestFrom! " + requestFrom
          );
          break;
      }
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
    async getCreatedDataCatId(dataCatEntry: any, catUri: string) {
      this.dpRequest.filter = [
        {
          fieldName: "dataset_name",
          filterOperator: 7,
          value: [dataCatEntry?.dataset_name.val],
          conditionOperator: 0,
        },
      ];
      await useCatalog()
        .getTableData({
          catalogUri: catUri,
          request: this.dpRequest,
        })
        .then(() => {
          this.selectedDataCatId = this.tableData?.rows[0][0];
        });
      this.dpRequest.filter = [];
    },
    async setUpdateLogId(catUri: string) {
      const data = await useCatalog().getTableData({
        catalogUri: catUri,
        request: {
          orderBys: [{ columnName: "update_log_id", keyword: "desc" }],
          filter: this.selectedDataCatId
            ? [
                {
                  fieldName: "data_cat_id",
                  filterOperator: 0,
                  value: this.selectedDataCatId,
                  conditionOperator: 0,
                },
              ]
            : [],
        },
        updateState: false,
      });
      this.updateLogId = data.rows[0][0];
    },
  },
});
